<div [class.loader-hidden]="!loaderService.isShow">
    <div class="loading">
            <div>
                <mat-spinner mode="indeterminate" *ngIf="loaderService.isShow"></mat-spinner>
            </div>
    </div>
</div>